// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import storage from './storage'
import store from './store'
import Directive from './common/directive'
import '@/assets/style/less.less'
import '@/assets/style/index.scss'
import Filters from '@/common/filter'
import Common from '@/common'
import '@/assets/style/homeContaint.less'

Vue.use(Filters);
Vue.use(Directive);
Vue.use(Common);
Vue.use(storage);

Vue.config.productionTip = false;

/* eslint-disable no-new */
window.vm = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
});

// (function () {
//   // app= 0|唐小僧 1|侨金所 2|赣金所 3|马上贷 4|外高桥
//   var baseUrl = "https://uatzc.txslicai.com/js/zbdata.js?app=5&"+'v='+ (new Date()).getTime();
//   var ma = document.createElement('script');
//   ma.type = 'text/javascript';
//   ma.src = baseUrl;
//   ma.id = 'zbdata';
//   var s = document.getElementsByTagName('body')[0];
//   s.appendChild(ma);
// })();



// WEBPACK FOOTER //
// ./src/main.js